<template>
  <Section id="engine" tone="muted" pad-y="lg" aria-labelledby="modules-heading">
    <Container>
      <div class="mb-10 flex flex-col gap-3">
        <h2 id="modules-heading" class="text-3xl font-bold text-ink-strong md:text-4xl">
          {{ t('sections.modules.title') }}
        </h2>
        <p class="max-w-2xl text-base text-ink-muted md:text-lg">
          {{ t('sections.modules.subtitle') }}
        </p>
      </div>
      <Grid :cols="{ base: 1, md: 2, lg: 4 }" :gap="4">
        <ModuleCard
          v-for="mod in ENGINE_MODULES"
          :key="mod.id"
          :title="moduleTitle(mod)"
          :description="moduleDescription(mod)"
          :status="mod.status"
          :status-label="statusLabel(mod.status)"
          :icon="mod.icon"
        />
      </Grid>
      <!--<div class="mt-10 flex justify-center">
        <BaseButton variant="primary" size="lg" as="router-link" :to="calculatorTo">
          {{ t('cta.calcEstimate') }}
        </BaseButton>
      </div>-->
    </Container>

    <Modal
      :open="active !== null"
      :title="active ? moduleTitle(active) : ''"
      size="md"
      @update:open="(v) => !v && (active = null)"
    >
      <p v-if="active" class="text-sm text-ink md:text-base">{{ moduleDescription(active) }}</p>
    </Modal>
  </Section>
</template>

<script setup lang="ts">
import { /*computed,*/ ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Section from '@/components/primitives/Section.vue';
import Container from '@/components/primitives/Container.vue';
import Grid from '@/components/primitives/Grid.vue';
//import BaseButton from '@/components/base/BaseButton.vue';
import Modal from '@/components/feedback/Modal.vue';
import ModuleCard from '@/components/domain/ModuleCard.vue';
import { ENGINE_MODULES, type ModuleItem } from '@/content/home-data';
import { useLocale } from '@/composables/useLocale';
import { pickLocalized } from '@/lib/i18n/localize';

const { t } = useI18n();
const { locale } = useLocale();

const active = ref<ModuleItem | null>(null);

function statusLabel(status: ModuleItem['status']): string {
  if (status === 'ready') return t('status.ready');
  if (status === 'beta') return t('status.beta');
  return t('status.planned');
}

function moduleTitle(mod: ModuleItem): string {
  return pickLocalized(mod, 'title', locale.value);
}

function moduleDescription(mod: ModuleItem): string {
  return pickLocalized(mod, 'description', locale.value);
}

//const calculatorTo = computed(() => `/${locale.value}/calculator`);
</script>
